import { render, staticRenderFns } from "./detailsOutboundReviewListRecord.vue?vue&type=template&id=377dd3ea&scoped=true"
import script from "./detailsOutboundReviewListRecord.vue?vue&type=script&lang=js"
export * from "./detailsOutboundReviewListRecord.vue?vue&type=script&lang=js"
import style0 from "./detailsOutboundReviewListRecord.vue?vue&type=style&index=0&id=377dd3ea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377dd3ea",
  null
  
)

export default component.exports